<template>
  <header class="topbar">
    <div class="topbar-left">
      <h1 class="page-title">{{ pageTitle }}</h1>
    </div>

    <div class="topbar-right">
      <button
        v-if="pmsName"
        class="pms-chip"
        @click="goToHub"
        title="Switch PMS"
      >
        <span class="pms-dot"></span>
        <span class="pms-name">{{ pmsName }}</span>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="8 3 4 7 8 11"/><path d="M4 7h13a4 4 0 0 1 4 4v0"/><polyline points="16 21 20 17 16 13"/><path d="M20 17H7a4 4 0 0 1-4-4v0"/></svg>
      </button>

      <div class="user-menu-wrap" ref="userMenu">
        <button class="user-chip" @click="toggleMenu" :class="{ 'is-open': menuOpen }">
          <div class="user-avatar">{{ userInitial }}</div>
          <span class="user-name">{{ username }}</span>
          <svg class="chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
        </button>

        <transition name="menu-fade">
          <div v-if="menuOpen" class="user-menu">
            <div class="menu-user">
              <div class="menu-user-avatar">{{ userInitial }}</div>
              <div class="menu-user-info">
                <div class="menu-user-name">{{ username }}</div>
                <div class="menu-user-email" v-if="email">{{ email }}</div>
              </div>
            </div>
            <div class="menu-divider"></div>
            <router-link to="/settings" class="menu-item" @click="closeMenu">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>
              Settings
            </router-link>
            <router-link to="/" class="menu-item" @click="closeMenu">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>
              Switch PMS
            </router-link>
            <div class="menu-divider"></div>
            <button class="menu-item menu-item-danger" @click="handleLogout">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
              Sign out
            </button>
          </div>
        </transition>
      </div>
    </div>
  </header>
</template>

<script>
const ROUTE_TITLES = {
  Dashboard: 'Dashboard',
  Reservations: 'Reservations',
  Properties: 'Properties',
  Settings: 'Settings',
  MonthEnd: 'Month-end reports',
  XeroSettings: 'Finance',
  ReportsArchive: 'Reports',
  Maintenance: 'Maintenance',
  Admin: 'Administration',
  Hub: 'Workspace'
};

export default {
  name: 'Topbar',
  props: {
    title: { type: String, default: null }
  },
  data() {
    return {
      menuOpen: false,
      username: '',
      email: '',
      pmsName: ''
    };
  },
  computed: {
    pageTitle() {
      if (this.title) return this.title;
      if (this.$route.meta && this.$route.meta.title) return this.$route.meta.title;
      return ROUTE_TITLES[this.$route.name] || this.$route.name || '';
    },
    userInitial() {
      return (this.username && this.username.charAt(0).toUpperCase()) || 'U';
    }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
    },
    goToHub() {
      this.$router.push('/');
    },
    handleLogout() {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('selectedPmsConfig');
      this.closeMenu();
      this.$router.push('/login');
    },
    loadUser() {
      try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        this.username = user.username || user.email || 'User';
        this.email = user.email || '';
      } catch (e) {
        this.username = 'User';
        this.email = '';
      }
    },
    loadPms() {
      try {
        const pms = JSON.parse(localStorage.getItem('selectedPmsConfig') || 'null');
        this.pmsName = (pms && pms.name) || '';
      } catch (e) {
        this.pmsName = '';
      }
    },
    handleClickOutside(e) {
      if (this.$refs.userMenu && !this.$refs.userMenu.contains(e.target)) {
        this.closeMenu();
      }
    },
    handleKeydown(e) {
      if (e.key === 'Escape' && this.menuOpen) {
        this.closeMenu();
      }
    }
  },
  mounted() {
    this.loadUser();
    this.loadPms();
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeydown);
  }
};
</script>

<style scoped>
*, *::before, *::after { box-sizing: border-box; }

.topbar {
  background: #ffffff;
  border-bottom: 1px solid #ebe9f8;
  padding: 0 28px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 50;
  font-family: 'DM Sans', sans-serif;
}

.topbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.page-title {
  font-family: 'Bricolage Grotesque', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #12113a;
  letter-spacing: -0.3px;
  margin: 0;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.topbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

/* ── PMS CHIP ── */
.pms-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px 7px 10px;
  background: rgba(128,117,240,0.08);
  border: 1px solid rgba(128,117,240,0.22);
  border-radius: 100px;
  color: #4a4870;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  font-family: inherit;
  max-width: 240px;
}

.pms-chip:hover {
  background: rgba(128,117,240,0.14);
  border-color: rgba(128,117,240,0.4);
  color: #12113a;
}

.pms-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #10b981;
  box-shadow: 0 0 0 3px rgba(16,185,129,0.18);
  flex-shrink: 0;
}

.pms-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'Bricolage Grotesque', sans-serif;
  letter-spacing: -0.2px;
}

.pms-chip svg {
  color: #9896b8;
  flex-shrink: 0;
}

/* ── USER CHIP ── */
.user-menu-wrap {
  position: relative;
}

.user-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 5px 10px 5px 5px;
  background: #f5f3ff;
  border: 1px solid #ebe9f8;
  border-radius: 100px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
  font-family: inherit;
}

.user-chip:hover,
.user-chip.is-open {
  background: rgba(128,117,240,0.08);
  border-color: rgba(128,117,240,0.28);
}

.user-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #5b58d4 0%, #7b52c8 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  font-family: 'Bricolage Grotesque', sans-serif;
  letter-spacing: -0.3px;
  flex-shrink: 0;
}

.user-name {
  font-size: 13px;
  font-weight: 600;
  color: #12113a;
  max-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chev {
  color: #9896b8;
  transition: transform 0.15s ease;
  flex-shrink: 0;
}

.user-chip.is-open .chev {
  transform: rotate(180deg);
}

/* ── DROPDOWN MENU ── */
.user-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 240px;
  background: white;
  border: 1px solid #ebe9f8;
  border-radius: 12px;
  box-shadow:
    0 4px 6px rgba(15,14,46,0.04),
    0 12px 32px rgba(15,14,46,0.12);
  padding: 6px;
  z-index: 100;
}

.menu-fade-enter-active,
.menu-fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.menu-fade-enter-from,
.menu-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

.menu-user {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px 12px;
}

.menu-user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #5b58d4 0%, #7b52c8 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  font-family: 'Bricolage Grotesque', sans-serif;
  letter-spacing: -0.3px;
  flex-shrink: 0;
}

.menu-user-info {
  min-width: 0;
  flex: 1;
}

.menu-user-name {
  font-family: 'Bricolage Grotesque', sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #12113a;
  letter-spacing: -0.2px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.menu-user-email {
  font-size: 11px;
  color: #9896b8;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.menu-divider {
  height: 1px;
  background: #ebe9f8;
  margin: 4px 0;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 12px;
  border-radius: 8px;
  background: transparent;
  border: none;
  color: #4a4870;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.12s ease, color 0.12s ease;
  font-family: inherit;
  text-align: left;
}

.menu-item svg {
  color: #9896b8;
  transition: color 0.12s ease;
  flex-shrink: 0;
}

.menu-item:hover {
  background: #f5f3ff;
  color: #12113a;
}

.menu-item:hover svg {
  color: #5b58d4;
}

.menu-item-danger {
  color: #dc2626;
}

.menu-item-danger svg {
  color: #dc2626;
}

.menu-item-danger:hover {
  background: #fef2f2;
  color: #dc2626;
}

.menu-item-danger:hover svg {
  color: #dc2626;
}

/* ── RESPONSIVE ── */
@media (max-width: 768px) {
  .topbar {
    padding: 0 16px;
  }

  .user-name,
  .pms-chip {
    display: none;
  }

  .user-chip {
    padding: 5px;
  }

  .chev {
    display: none;
  }
}
</style>
